"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareButton = void 0;
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Share button component.
 * Contains IconButton from @ori-ui/components and Share icon from @ori-ui/icons
 */
const ShareButton = props => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ShareIconButton, {
    "data-testid": getTestId(_constants.SHARE_BUTTON),
    color: "default",
    size: "large",
    variant: "contained",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Share, {
      fontSize: "inherit"
    })
  });
};
exports.ShareButton = ShareButton;
